import React, { createContext, useContext, useMemo, PropsWithChildren } from 'react';
import { LegacyPlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export type PlayerBaseInfoContent = LegacyPlayerBaseInfoContent | null;

type PlayerBaseInfoContextValue = {
    getPlayerBaseInfo: () => { content: PlayerBaseInfoContent } | null;
};

const PlayerBaseInfoContext = createContext<PlayerBaseInfoContextValue | null>(null);

type PlayerBaseInfoProviderProps = PropsWithChildren<{
    value: PlayerBaseInfoContent;
}>;

export function PlayerBaseInfoProvider({ value, children }: PlayerBaseInfoProviderProps) {
    const contextValue = useMemo<PlayerBaseInfoContextValue>(
        () => ({
            ...value,
            getPlayerBaseInfo() {
                if (value === null) {
                    return null;
                }

                return { content: value };
            },
        }),
        [value]
    );

    return (
        <PlayerBaseInfoContext.Provider value={contextValue}>
            {children}
        </PlayerBaseInfoContext.Provider>
    );
}

export function usePlayerBaseInfoContext(): PlayerBaseInfoContextValue {
    const context = useContext(PlayerBaseInfoContext);

    if (!context) {
        throw new Error('usePlayerBaseInfoContext must be used within a PlayerBaseInfoProvider');
    }

    return context;
}
